export const dienstenImages = [
  "/img/92-foto.jpeg",
  "/img/100-foto.jpeg",
  "/img/87-foto.jpeg",
  "/img/95-foto.jpeg",
  "/img/96-foto.jpeg",
  "/img/89-foto.jpeg",
  "/img/83-foto.jpeg",
  "/img/85-foto.jpeg",
  "/img/45-various-window-handles-white.jpg",
];